import { ApiResult, request, safeRequest } from '@synergy/api';

import { DefaultDeliveryOptionsDto } from '../models/dto/default-delivery-options-dto';
import { DefaultDeliveryOptionsRequest } from './models/default-delivery-options-request';
import { DeliveryOptions } from '../models/delivery-options';
import { DeliveryOptionsDto } from '../models/dto/delivery-options-dto';

export class ShoppingCartDeliveryOptionsApi {
    constructor(protected baseUrl: string) {}

    public getDeliveryOptions = (): Promise<ApiResult<DeliveryOptionsDto>> => {
        return safeRequest(
            () => request.get(`${this.baseUrl}/shopping-cart/delivery-options`),
            response => response.data
        );
    };

    public setInvoiceAddress = (invoiceAddressId: number): Promise<ApiResult> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/shopping-cart/details`, { invoiceAddressId: invoiceAddressId }),
            response => response.data
        );
    };

    public setDeliveryAddress = (deliveryAddressId: number): Promise<ApiResult<DeliveryOptions>> => {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/shopping-cart/details`, {
                    deliveryAddressId: deliveryAddressId,
                }),
            response => response.data
        );
    };

    public setAvisoContact = (avisoContactId: number | null): Promise<ApiResult<DeliveryOptions>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/shopping-cart/details`, { avisoContactId }),
            response => response.data
        );
    };

    public setDesiredDeliveryDate = (desiredDeliveryDate: Date | null): Promise<ApiResult<DeliveryOptions>> => {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/shopping-cart/details`, {
                    desiredDeliveryDate: desiredDeliveryDate,
                }),
            response => response.data
        );
    };

    public setCostCentre = (costCentre: string): Promise<ApiResult<DeliveryOptions>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/shopping-cart/details`, { costCentre: costCentre || null }),
            response => response.data
        );
    };

    public setOrderReference = (orderReference: string | null): Promise<ApiResult<DeliveryOptions>> => {
        return safeRequest(
            () =>
                request.post(`${this.baseUrl}/shopping-cart/details`, {
                    orderReference: orderReference,
                }),
            response => response.data
        );
    };

    public changeDefaultDeliveryOptions = (
        defaultDeliveryOptions: DefaultDeliveryOptionsRequest
    ): Promise<ApiResult<DefaultDeliveryOptionsDto>> => {
        return safeRequest(
            () => request.post(`${this.baseUrl}/shopping-cart/defaults`, defaultDeliveryOptions),
            response => response.data
        );
    };
}
